<!--
Copyright 2020 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <modal id="public-link-revoke" :state="state" :hideable="!awaitingResponse"
    backdrop @hide="$emit('hide')">
    <template #title>{{ $t('title') }}</template>
    <template #body>
      <div class="modal-introduction">
        <p>{{ $t('introduction[0]') }}</p>
        <p><strong>{{ $t('common.areYouSure') }}</strong></p>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-danger"
          :disabled="awaitingResponse" @click="revoke">
          {{ $t('action.yesProceed') }} <spinner :state="awaitingResponse"/>
        </button>
        <button type="button" class="btn btn-link" :disabled="awaitingResponse"
          @click="$emit('hide')">
          {{ $t('action.noCancel') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../modal.vue';
import Spinner from '../spinner.vue';
import request from '../../mixins/request';
import { apiPaths } from '../../util/request';
import { noop } from '../../util/util';

export default {
  name: 'PublicLinkRevoke',
  components: { Modal, Spinner },
  mixins: [request()],
  props: {
    state: {
      type: Boolean,
      default: false
    },
    publicLink: Object // eslint-disable-line vue/require-default-prop
  },
  data() {
    return {
      awaitingResponse: false
    };
  },
  methods: {
    revoke() {
      this.request({
        method: 'DELETE',
        url: apiPaths.session(this.publicLink.token)
      })
        .then(() => {
          this.$emit('success', this.publicLink);
        })
        .catch(noop);
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is the title at the top of a pop-up.
    "title": "Revoke Public Access Link",
    "introduction": [
      "You are about to revoke this Public Access Link. This means all attempts to submit data using the link will be denied, including records that have already been started."
    ]
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "Odebrat veřejně přístupný odkaz",
    "introduction": [
      "Chystáte se odebrat tento veřejně přístupný odkaz. To znamená, že všechny pokusy o odeslání dat pomocí odkazu budou zamítnuty, včetně záznamů, které již byly spuštěny."
    ]
  },
  "de": {
    "title": "Öffentlichen Zugangslink widerrufen",
    "introduction": [
      "Sie sind dabei diesen öffentlichen Zugriffslink zu widerrufen. Das bedeutet, alle Versuche Daten über diesen Link zu übermitteln, werden abgewiesen, einschließlich Aufzeichnungen, die bereits begonnen wurden."
    ]
  },
  "es": {
    "title": "Revocar enlace de acceso público",
    "introduction": [
      "Está a punto de revocar este enlace de acceso público. Esto significa que cualquier intento de enviar datos utilizando el enlace será denegado, incluyendo los registros que ya han sido iniciados."
    ]
  },
  "fr": {
    "title": "Révoquer lien d'accès public",
    "introduction": [
      "Vous êtes sur le point de révoquer ce lien d'accès public. Toute tentative de soumission de données utilisant le lien sera refusée, y compris les formulaires qui ont déjà été commencés."
    ]
  }
}
</i18n>
